export default class FeedbackEvent {
    constructor(type) {
        this.type = type;
    }
}


FeedbackEvent.OPEN_SCREEN_REQUEST = "FeedbackEvent.OPEN_SCREEN_REQUEST";
FeedbackEvent.CLOSE_SCREEN_REQUEST = "FeedbackEvent.CLOSE_SCREEN_REQUEST";
FeedbackEvent.SWITCH_ANSWERS_VIEW_REQUEST = "FeedbackEvent.SWITCH_ANSWERS_VIEW_REQUEST";
FeedbackEvent.MOVE_TO_NEXT_KD_REQUEST = "FeedbackEvent.MOVE_TO_NEXT_KD_REQUEST";
FeedbackEvent.MOVE_TO_PREVIOUS_KD_REQUEST = "FeedbackEvent.MOVE_TO_PREVIOUS_KD_REQUEST";

FeedbackEvent.MOVE_TO_KD_REQUEST = "FeedbackEvent.MOVE_TO_KD_REQUEST";